
export default {
  namespaced: true,
  state: () => ({
    hideNavBar: false,
  }),
  mutations: {
    setHideNavBar (state, hideNavBar) {
      state.hideNavBar = hideNavBar
    }
  },
}